// Interrupted-upload detection is derived from a lightweight sessionStorage
// record — NOT from a server-side flag. If the tab closes mid-upload, the
// record survives; the next time the user opens the project the Footage tab
// checks for this record and shows the interrupted banner.
//
// Deliberately does not persist across browser sessions (sessionStorage,
// not localStorage): after a full quit the user's next visit starts clean.
// A cleaner "resume across quits" would need server-side batch tracking,
// which is explicitly out of scope for this phase.

const KEY_PREFIX = 'tweedia:photoBatch:';

function keyFor(projectId) {
  return `${KEY_PREFIX}${projectId}`;
}

function safeStorage() {
  try {
    if (typeof sessionStorage === 'undefined') return null;
    return sessionStorage;
  } catch (_err) {
    return null;
  }
}

export function beginBatch(projectId, meta = {}) {
  const s = safeStorage();
  if (!s || !projectId) return;
  try {
    s.setItem(keyFor(projectId), JSON.stringify({
      startedAt: Date.now(),
      completedAt: null,
      ...meta,
    }));
  } catch (_err) { /* quota — best effort */ }
}

export function completeBatch(projectId) {
  const s = safeStorage();
  if (!s || !projectId) return;
  try { s.removeItem(keyFor(projectId)); } catch (_err) { /* ignore */ }
}

export function readBatch(projectId) {
  const s = safeStorage();
  if (!s || !projectId) return null;
  try {
    const raw = s.getItem(keyFor(projectId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (_err) {
    return null;
  }
}
